module.exports = __webpack_public_path__ + "static/media/image82.12451536.png";